(ns nosco.richtext.prosemirror
  "Functions for working with Prosemirror."
  (:require
   ["prosemirror-state" :as pm-state]))

(defn apply-tr
  "Applies the transaction returned by calling (apply f state args), returning the new state."
  [state f & args]
  (.. ^js state (apply (apply f state args))))

(defn ->text-selection [doc from to]
  (.. pm-state/TextSelection (create doc from to)))

(defn set-selection-tr [state selection]
  (.. ^js state -tr (setSelection selection)))

(defn select-text-tr [state from to]
  (set-selection-tr state (->text-selection (.-doc state) from to)))

(defn selected-text [state]
  (.. ^js state -doc (textBetween (.. ^js state -selection -from) (.. ^js state -selection -to))))

(defn replace-selection-tr [state slice]
  (.. ^js state -tr (replaceSelection slice)))

(defn delete-selection-tr [state]
  (.. ^js state -tr (deleteSelection)))

(defn insert-slice-tr [state pos slice]
  (.. ^js state -tr (insert pos (.-content slice))))

(defn map-fragment
  "Returns a vector containing the result of applying f to the content of a fragment.
  f receives the Node object, its offset into the parent node, and its index."
  [f fragment]
  (let [result (volatile! (transient []))]
    (.. fragment
        (forEach
         (fn [node offset index]
           (vswap! result conj! (f node offset index)))))
    (persistent! @result)))
